import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { map, Observable } from 'rxjs';
import { IProjectInfo } from '@shared/model/project';
import { IField } from '@shared';
import { BackendApiProjectsService } from '@app/backend/metadoor-api-client';

@Injectable({
  providedIn: 'root',
})
export class ProjectService {
  private _baseUrl: string = `${environment.apiUrl}/projects/projects`;

  constructor(
    private _http: HttpClient,
    private _route: Router,
    private _bakendProjectsService: BackendApiProjectsService,
  ) {}

  getProjectInfo(id: number): Observable<IProjectInfo> {
    return this._http
      .get<
        Omit<IProjectInfo, 'currency_multiplication'> & { currency_multiplication: null | string }
      >(`${this._baseUrl}/${id}/info/`)
      .pipe(
        map((res) => {
          // NOTE: currency_multiplication не должно быть null
          res.currency_multiplication = res.currency_multiplication === null ? '' : res.currency_multiplication;
          return res as IProjectInfo;
        }),
      );
  }

  updateProjectField(id: number, data: IField): Observable<any> {
    return this._http.patch(`${this._baseUrl}/${id}/`, {
      [data.name]: data.value,
    });
  }

  changeProjectConfig(id: number) {
    this._route.navigate(['projects', 'config', id]);
  }

  uploadLogoFile(id: number, file: File, file_type: string = '0'): Observable<any> {
    const formData = new FormData();

    formData.append('file', file);
    formData.append('file_type', file_type);
    console.log('id', id);
    const params = {
      id,
      body: {
        file,
      },
    };
    return this._bakendProjectsService.projectsProjectsLogoUpdateUpdate(params);
  }

  deleteLogoFile(id: number): Observable<any> {
    return this._http.delete(`${this._baseUrl}/logo/update/${id}/`);
  }
}
